import { Nav } from "reactstrap";
import { Devices } from "../../../../../../styles";
import styled from "styled-components";

const TabNav = styled(Nav)`
  margin-left: auto;
  margin-bottom: 1rem;
  gap: 12px;
  @media ${Devices.desktop} {
    gap: 20px;
  }
`;

export default TabNav;
